<div class="user-photo">
    @if(imageSource != null){
        <img [src]="imageSource" alt="{{'header.profile.aria.userphoto' | translate}}">
    }
</div>
